import React, { useEffect, useRef } from "react";
import { motion, useReducedMotion } from "framer-motion";
import { offer } from "../data/offer";
import { images, links } from "../data/images";
import { PrimaryButton } from "./PrimaryButton";
import { PriceStack } from "./PriceStack";
import { ProtocolContents } from "./ProtocolContents";
import { UrgencyReasons } from "./UrgencyReasons";
import { ReviewsSection } from "./ReviewsSection";
import { GuaranteeSection } from "./GuaranteeSection";
const BURST = Array.from({
  length: 14
}, (_, i) => i);
const BURST_COLORS = ["bg-rose-600", "bg-rose-400", "bg-leaf", "bg-gold"];
export function OfferReveal() {
  const reduce = useReducedMotion();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current?.scrollIntoView({
      behavior: reduce ? "auto" : "smooth",
      block: "start"
    });
  }, [reduce]);
  return <div ref={ref} className="scroll-mt-24" data-id="element-115" data-mp="cfxye3okt5i2">
      <div className="relative mt-12" data-id="element-116" data-mp="hhdj1umud9zx">
        {!reduce && <div className="pointer-events-none absolute left-1/2 top-10 z-10" aria-hidden="true" data-id="element-117" data-mp="22evef578oxhz">
            {BURST.map(i => {
          const angle = i / BURST.length * Math.PI * 2;
          return <motion.span key={i} className={`absolute h-2.5 w-2.5 rounded-full ${BURST_COLORS[i % BURST_COLORS.length]}`} initial={{
            x: 0,
            y: 0,
            opacity: 1,
            scale: 1
          }} animate={{
            x: Math.cos(angle) * 160,
            y: Math.sin(angle) * 110,
            opacity: 0,
            scale: 0.6
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-118" data-mp="2c57w8pno6ckf" />;
        })}
          </div>}

        <motion.div className="overflow-hidden rounded-3xl border border-blush-200 bg-white" initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.6,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={reduce ? {
        duration: 0.2
      } : {
        type: "spring",
        stiffness: 260,
        damping: 11,
        mass: 0.9
      }} data-id="element-119" data-mp="1of3s8h6kkasw">
          <div className="grid md:grid-cols-[1fr_1.15fr]" data-id="element-120" data-mp="37u6ybq22z826">
            <img src={images.product} alt="Portada del recetario Cenas Anti-inflamatorias: Vientre plano en 15 minutos, en una tablet" className="h-full min-h-[240px] w-full object-cover object-center" data-id="element-121" data-mp="3bw0txjxf5lvh" />
            <div className="flex flex-col justify-center p-6 sm:p-8" data-id="element-122" data-mp="3ltye9wc5qyit">
              <p className="text-sm font-semibold text-olive-700" data-id="element-123" data-mp="2o8ajffvcoo9e">Tu recomendación personalizada</p>
              <h3 className="mt-2 font-serif text-2xl font-semibold leading-tight text-cocoa sm:text-3xl" data-id="element-124" data-mp="2t6u6jjlok63c">
                {offer.productName}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-cocoa-soft" data-id="element-125" data-mp="32vlw5l39qeb3">
                Un sistema práctico para mujeres de más de 35 que quieren cenar comida real, sin pasar hambre, sin
                ingredientes raros y sin volver a depender de ensaladas frías, yogur o tostadas improvisadas.
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.45,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-126" data-mp="1xwz1kykcwfl6">
        <ProtocolContents data-id="element-127" data-mp="1szyt6h01b0qw" />
        <UrgencyReasons data-id="element-128" data-mp="1nz1cy9yl4gs1" />
        <ReviewsSection data-id="element-129" data-mp="1nxrcxf868yir" />
        <PriceStack data-id="element-130" data-mp="1ny9kv947516i" />

        <p className="mx-auto mt-12 max-w-2xl text-center font-serif text-xl italic leading-relaxed text-cocoa sm:text-2xl" data-id="element-131" data-mp="1o15fangu57q7">
          Esta noche podés volver a improvisar la cena de siempre… o podés empezar con un método diseñado para que tu
          cuerpo deje de pelear con la digestión mientras intenta descansar.
        </p>
        <div className="mx-auto mt-6 max-w-md" data-id="element-132" data-mp="158tew69qsgip">
          <PrimaryButton href={links.checkout} data-id="element-133" data-mp="15a4hi2rgbi88">Empezar hoy con mis cenas antiinflamatorias</PrimaryButton>
        </div>
        <GuaranteeSection data-id="element-134" data-mp="10b1bog3nd7z7" />
      </motion.div>
    </div>;
}